import styled, { css } from 'styled-components'
import { Size } from '../../utilities/Devices'

interface IContainerProps {
  align?: string
  flex?: boolean
  fullWidth?: boolean
  responsive?: boolean
  reverse?: boolean
}

export const Container = styled.div<IContainerProps>`
  margin-left: auto;
  margin-right: auto;
  max-width: ${props =>
    props.fullWidth ? '100%' : 'var(--container-max-width)'};
  padding-left: 1rem;
  padding-right: 1rem;
  box-sizing: content-box;

  @media (max-width: ${Size.medium}) {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  ${props =>
    props.flex &&
    css`
      align-items: stretch;
      display: flex;
      justify-content: space-between;
    `}
  ${props =>
    props.flex &&
    props.reverse &&
    css`
      flex-direction: row-reverse;
    `}
  ${props =>
    props.flex &&
    props.align &&
    css`
      align-items: ${props.align};
    `}

  ${props =>
    props.responsive &&
    css`
      @media (max-width: ${Size.small}) {
        flex-direction: column;
      }
    `}
`
